import styled from 'styled-components';

export const APPLICATION_CONTENT_MAX_WIDTH = 1170;

export const MainContent = styled.div`
  max-width: ${APPLICATION_CONTENT_MAX_WIDTH}px;
  flex: 1;
`;
